export default "__VITE_ASSET__B0o$hL42__"